import {
  ApiChartTemplate,
  ApiChartType,
  ApiDimension,
  ApiMetric,
} from "@incendium/api";
import { Grid, Typography } from "@mui/material";
import SetupNeeded from "Components/UI/SetupNeeded";
import { formatEnumVal } from "Helpers/enumToText";
import { useTrafficBuckets } from "Hooks/useTrafficBuckets";
import AnalyticsCard from "features/analytics/components/AnalyticsCard";
import { AnalyticsSpacing } from "consts";

interface IBucketsROIChartsProps {
  dimensions: ApiDimension[];
}

function BucketsROICharts({ dimensions }: IBucketsROIChartsProps) {
  const { loading: bucketsLoading, rOIBuckets } = useTrafficBuckets();

  return (
    <Grid container spacing={AnalyticsSpacing}>
      <Grid item xs={12}>
        {!bucketsLoading && rOIBuckets.length === 0 ? (
          <SetupNeeded>
            <Typography variant="subtitle1" mb={1}>
              Insights not available
            </Typography>
          </SetupNeeded>
        ) : (
          <Grid container spacing={AnalyticsSpacing}>
            {rOIBuckets.map((bucket) => (
              <Grid item key={bucket.name} xs={4} sx={{ minHeight: 450 }}>
                <AnalyticsCard
                  chart={{
                    name: `${formatEnumVal(
                      (bucket.name || "").replace("ATTRIBUTION_TAG_", "")
                    )} ROI`,
                    dimension: [dimensions[0]],
                    template: ApiChartTemplate.TABLE,
                    type: ApiChartType.TABLE,
                    attributes: (bucket.bucketNames || []).map((b) => ({
                      key: ApiDimension.DIMENSION_SOURCE_BUCKET,
                      value: b,
                    })),
                    limit: 5,
                    yAxisKeys: [
                      {
                        key: "l",
                        fields: [
                          ApiMetric.METRIC_ROAS_LAST,

                          ApiMetric.METRIC_SESSION_EFFICIENCY_RATIO,
                          ApiMetric.METRIC_MACRO_CONVERSIONS_COUNT,
                          ApiMetric.METRIC_REVENUE,
                        ],
                      },
                    ],
                    displayOptions: {
                      noFilters: true,
                      rowsPerPage: 4,
                      noAttributionToggle: true,
                      availableDimensions:
                        dimensions.length > 1 ? dimensions : undefined,
                    },
                  }}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}

export default BucketsROICharts;
